import FormButton from "../Components/Buttons/FormButton";
import FormSelect from "../Components/FormTag/FormSelect";
import { assignUser } from "../Data/dropdownDataList";
import { useForm } from "react-hook-form";
import { Search } from 'react-bootstrap-icons';

const AssignToUserLayout = ({ handleClose }: { handleClose: () => void }) => {
    const onSubmit = (data: any) => {
        console.log('Form submitted:', data);
        handleClose(); 
    };

    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm<typeof assignUser>({
        defaultValues: assignUser,
    });

    const handleCancel = () => {
        handleClose();
    };

    const handleFormSubmit = () => {
        handleSubmit(onSubmit)();
    };

    return (
        <>
            <div className="form">
                <div className="d-flex justify-content-center">
                    <div className="col-12 col-md-8 col-lg-6">
                        <div className="px-2">
                            <label className="w-100 text-center fs-16 mb-2">Search User</label>
                            <FormSelect
                                name="assignUser"
                                tabIndex={1}
                                control={control}
                                optionList={assignUser}
                                required={true}
                                className="form-control p-0"
                                placeholder={<div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Search style={{ marginRight: '5px' }} />
                                    Search
                                </div>}
                                isSearchable={true}
                            />
                        </div>
                    </div>
                </div>

                <div className="d-flex justify-content-end mt-4 gap-2">
                    <FormButton
                        tabIndex={26}
                        className="sph-btn sph-shift"
                        handleClick={handleCancel}>
                        Cancel
                    </FormButton>
                    <FormButton
                        tabIndex={25}
                        className="sph-btn me-2"
                        handleClick={handleFormSubmit}>
                        Submit
                    </FormButton>
                </div>
            </div>
        </>
    );
};

export default AssignToUserLayout;
